import { ServiceFetch } from '../service-fetch'

export default class StockCardModel extends ServiceFetch {
    coundStockCardBy = (data) => this.authFetch({
        url: 'stock-card/coundStockCardBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
    getStockCardBy = (data) => this.authFetch({
        url: 'stock-card/getStockCardBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
    getStockCardGroupByRefCode = (data) => this.authFetch({
        url: 'stock-card/getStockCardGroupByRefCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
    getLastDateStockCardBy = (data) => this.authFetch({
        url: 'stock-card/getLastDateStockCardBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
    runStockCardMaintenance = (data) => this.authFetch({
        url: 'stock-card/runStockCardMaintenance',
        method: 'POST',
        body: JSON.stringify(data),
    })
}